// Identity context that rides on every log record so frontend events can be
// correlated with backend traces.
//
//   sessionId — stable for the whole browser session (until tab close / hard reload).
//   userId    — set on login success, cleared on logout.
//
// Use `core/monitoring/identifyUser` from the auth flow rather than calling
// `setUserId` here directly — that helper also notifies Sentry so the sinks
// stay in sync.

const BASE_36 = 36

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  return `s-${Math.random().toString(BASE_36).slice(2)}-${Date.now().toString(BASE_36)}`
}

const sessionId = generateId()
let userId: string | null = null

export const getSessionId = (): string => sessionId
export const getUserId = (): string | null => userId

export const setUserId = (id: string | null): void => {
  userId = id
}
